/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  FastEndpointsProblemDetails,
  FxIdWebFeaturesStoreFacebookInstantGamesPurchaseRequest,
  FxIdWebFeaturesStoreFacebookInstantGamesPurchaseResponse,
} from '../models/index';
import {
    FastEndpointsProblemDetailsFromJSON,
    FastEndpointsProblemDetailsToJSON,
    FxIdWebFeaturesStoreFacebookInstantGamesPurchaseRequestFromJSON,
    FxIdWebFeaturesStoreFacebookInstantGamesPurchaseRequestToJSON,
    FxIdWebFeaturesStoreFacebookInstantGamesPurchaseResponseFromJSON,
    FxIdWebFeaturesStoreFacebookInstantGamesPurchaseResponseToJSON,
} from '../models/index';

export interface FxIdWebFeaturesStoreFacebookInstantGamesPurchaseEndpointRequest {
    fxIdWebFeaturesStoreFacebookInstantGamesPurchaseRequest: FxIdWebFeaturesStoreFacebookInstantGamesPurchaseRequest;
}

/**
 * 
 */
export class FbinstantApi extends runtime.BaseAPI {

    /**
     * **MUTATES:** `bank131account`, `bank131order`, `orders`, `orderproduct`, `account_order_settings`, `accounts`  Start payment in facebook instant games 
     */
    async fxIdWebFeaturesStoreFacebookInstantGamesPurchaseEndpointRaw(requestParameters: FxIdWebFeaturesStoreFacebookInstantGamesPurchaseEndpointRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FxIdWebFeaturesStoreFacebookInstantGamesPurchaseResponse>> {
        if (requestParameters['fxIdWebFeaturesStoreFacebookInstantGamesPurchaseRequest'] == null) {
            throw new runtime.RequiredError(
                'fxIdWebFeaturesStoreFacebookInstantGamesPurchaseRequest',
                'Required parameter "fxIdWebFeaturesStoreFacebookInstantGamesPurchaseRequest" was null or undefined when calling fxIdWebFeaturesStoreFacebookInstantGamesPurchaseEndpoint().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWTBearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/fbinstant/purchase`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FxIdWebFeaturesStoreFacebookInstantGamesPurchaseRequestToJSON(requestParameters['fxIdWebFeaturesStoreFacebookInstantGamesPurchaseRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FxIdWebFeaturesStoreFacebookInstantGamesPurchaseResponseFromJSON(jsonValue));
    }

    /**
     * **MUTATES:** `bank131account`, `bank131order`, `orders`, `orderproduct`, `account_order_settings`, `accounts`  Start payment in facebook instant games 
     */
    async fxIdWebFeaturesStoreFacebookInstantGamesPurchaseEndpoint(fxIdWebFeaturesStoreFacebookInstantGamesPurchaseRequest: FxIdWebFeaturesStoreFacebookInstantGamesPurchaseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FxIdWebFeaturesStoreFacebookInstantGamesPurchaseResponse> {
        const response = await this.fxIdWebFeaturesStoreFacebookInstantGamesPurchaseEndpointRaw({ fxIdWebFeaturesStoreFacebookInstantGamesPurchaseRequest: fxIdWebFeaturesStoreFacebookInstantGamesPurchaseRequest }, initOverrides);
        return await response.value();
    }

}
